import { joiResolver } from '@hookform/resolvers/joi'
import { Box, DialogContent, Typography } from '@mui/material'
import joi from 'joi'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import {
  CLOSE_TYPES,
  SIZES,
} from '../../../../components/shared/dialog/dialog-layout/dialog-layout.constants'
import { styles as dialogStyles } from '../../../../components/shared/dialog/dialog-layout/dialog-layout.styles'
import Dialog from '../../../../components/shared/dialog/dialog.component'
import TextField from '../../../../components/shared/text-field/text-field.component'
import { SCHEMAS } from '@hapana/shared/utils/validations.util'
import {
  EMAIL_FIELD_NAME,
  EMAIL_FIELD_ID,
} from '../../../../components/shared/auth/forgot-password-form/forgot-password-form.constants'

const joiSchema = joi.object({
  [EMAIL_FIELD_NAME]: SCHEMAS.email,
})

const ForgotPasswordForm = ({
  formMethods: formMethodsProvided,
  onSubmit,
  modalPrimaryAction,
  modalSecondaryAction,
}) => {
  const { t } = useTranslation('common')

  const defaultFormMethods = useForm({
    resolver: joiResolver(joiSchema),
    defaultValues: {},
    mode: 'onTouched',
  })
  const formMethods = formMethodsProvided || defaultFormMethods

  const { handleSubmit } = formMethods

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} style={dialogStyles.form}>
        <Dialog
          title={t('modals.forgotPassword.dialogTitle')}
          closeType={CLOSE_TYPES.ICON}
          size={SIZES.XS}
          hasMobileBottomSheet
          primaryAction={modalPrimaryAction}
          secondaryAction={modalSecondaryAction}
        >
          <DialogContent>
            <Typography typography="medium" color="gray.80">
              {t('modals.forgotPassword.descriptionOne')}
            </Typography>
            <Typography typography="header4" color="gray.80">
              {t('modals.forgotPassword.descriptionTwo')}
            </Typography>
            <Box sx={dialogStyles.forgotPasswordWrapper}>
              <TextField
                label={t('modals.forgotPassword.email')}
                name={EMAIL_FIELD_NAME}
                id={EMAIL_FIELD_ID}
              />
            </Box>
          </DialogContent>
        </Dialog>
      </form>
    </FormProvider>
  )
}

export default ForgotPasswordForm

ForgotPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  // Dialog action descriptors ({ label, action, props }) — passed straight to
  // <Dialog primaryAction/secondaryAction>, not bare functions.
  modalPrimaryAction: PropTypes.object.isRequired,
  modalSecondaryAction: PropTypes.object,
  formMethods: PropTypes.object,
  defaultValues: PropTypes.object,
}
